import {
  RtlLayout,
  ScrollToTop,
  ThemeColorPresets,
  MotionLazyContainer,
  ProgressBarStyle,
  NotistackProvider,
} from '@onedesign/ui';
import {
  QueryClient,
  QueryClientProvider,
  QueryCache,
} from '@tanstack/react-query';
import './assets/css/toastify-custom-style.css';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import ThemeProvider from 'theme/ThemeProvider';
import { Routes } from 'routes/index';
import { LoadingProvider } from 'services/LoadingService';
import { LoginProvider } from 'services/LoginService';
import { ProfileProvider } from 'services/ProfileService';
import { NotificationProvider } from 'services/NotificationService';
import { FeatureToggleProvider } from 'services/FeatureToggleService';
import { TranslationProvider } from 'services/TranslationService';
import { toast, ToastContainer } from 'react-toastify';
import { TTL } from './constants/common';
import { CourseStatusServiceProvider } from './services/CourseStatusService';

export default function App() {
  const defaultStaleTime = 5 * TTL.ONE_MINUTE;
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: defaultStaleTime,
      },
    },
    queryCache: new QueryCache({
      onError: (error, query) => {
        // 標記 silentError 的 query 一律不跳提示。
        // 用於「失敗了老師不需要做任何處置」的請求 —— 例如會自動重試的定時列表、
        // 或前端有降級方案的查詢。跳紅字只會讓他以為出事了。
        if (query.meta?.silentError) return;

        if (error instanceof Error) {
          toast.error(error.message, {
            position: toast.POSITION.BOTTOM_LEFT,
          });
        }
      },
    }),
  });

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <ThemeColorPresets>
          <NotistackProvider>
            <LoadingProvider>
              <LoginProvider>
                <FeatureToggleProvider>
                  <TranslationProvider>
                    <ProfileProvider>
                      <NotificationProvider>
                        <CourseStatusServiceProvider>
                          <RtlLayout>
                            <MotionLazyContainer>
                              <ProgressBarStyle />
                              <ScrollToTop />
                              <ToastContainer />
                              <Routes />
                            </MotionLazyContainer>
                          </RtlLayout>
                        </CourseStatusServiceProvider>
                      </NotificationProvider>
                    </ProfileProvider>
                  </TranslationProvider>
                </FeatureToggleProvider>
              </LoginProvider>
            </LoadingProvider>
          </NotistackProvider>
        </ThemeColorPresets>
      </ThemeProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
